import React from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Col, InputNumber, Row, Select } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import PaymentGatewayController from '../front/settings/payment/payment.gateway.controller'
import i from '../translations/i'

export type GatewaySplitRow = { gateway_id: any, percent: any }

// Строки "шлюз + процент" для распределения суммы между платёжными шлюзами ЮKassa.
// Сумма процентов должна быть 100; пустой список = без распределения.
export const GatewaySplitEditor = observer(({ rows, onChange }: { rows: GatewaySplitRow[], onChange: (rows: GatewaySplitRow[]) => void }) => {

  const addRow = () => onChange([...rows, { gateway_id: null, percent: 0 }])
  const removeRow = (index: number) => onChange(rows.filter((_, i) => i !== index))
  const updateRow = (index: number, patch: Partial<GatewaySplitRow>) => onChange(rows.map((row, i) => i === index ? { ...row, ...patch } : row))

  const sum = rows.reduce((s, row) => s + (Number(row.percent) || 0), 0)

  return(
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {rows.map((row, index) => {
          const usedElsewhere = rows.filter((_, i) => i !== index).map(r => r.gateway_id)
          const gatewayOptions = PaymentGatewayController.list
            .filter((gateway: any) => !usedElsewhere.includes(gateway.id))
            .map((gateway: any) => ({ label: gateway.label, value: gateway.id }))

          return (
          <Row key={index} gutter={8} align="middle">
            <Col span={14}>
              <Select
                style={{ width: '100%' }}
                placeholder={i.t('def:select')}
                value={row.gateway_id}
                onChange={(e) => updateRow(index, { gateway_id: e })}
                options={gatewayOptions}
              />
            </Col>
            <Col span={6}>
              <InputNumber
                style={{ width: '100%' }}
                min={0}
                max={100}
                addonAfter="%"
                value={row.percent}
                onChange={(e) => updateRow(index, { percent: e })}
              />
            </Col>
            <Col span={4}>
              <Button icon={<DeleteOutlined />} shape="circle" danger onClick={() => removeRow(index)} />
            </Col>
          </Row>
          )
        })}
      </div>

      <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button size="small" onClick={addRow}>{i.t('def:actions.add')}</Button>

        {rows.length > 0 &&
          <span style={{ color: sum === 100 ? '#52c41a' : '#ff4d4f', fontSize: 12 }}>
            {sum}% {sum !== 100 && i.t('gatewaySplit:sumMustBe100')}
          </span>
        }
      </div>
    </>
  )
})
